import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CommandCenterReport } from "src/app/shared/models/CommandCenterReportConfiguration.item";

@Component({
	selector: "app-reports-categories",
	templateUrl: "./reports-categories.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class ReportsCategoriesComponent implements OnInit {
	@Input() category: string;
	@Output() categoryChange = new EventEmitter<string>();

	@Input() reports: CommandCenterReport[];

	@Output() reportsChange = new EventEmitter<CommandCenterReport[]>();

	@Input() reportSelected: CommandCenterReport;
	@Output() reportSelectedChange = new EventEmitter<CommandCenterReport>();
	constructor() {}

	ngOnInit(): void {}
}
